module.exports = __webpack_public_path__ + "img/tabelleloeschen.8720c30.svg";